import React from 'react';
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import { autobind } from 'core-decorators';
import http from 'src/services/httpService';
import history from '../../history';
import moment from 'moment';
import List from '../../componentes/list';
import ListColumn from '../../componentes/list/list-column';
import AcaoEdit from './edit';
import ContentManager from '../../componentes/content-manager';
import SvgIcon from '../../componentes/svg-icon';
import Search from './search';
import SearchAtualizarAcao from './search-atualizar-acao';
import SearchSchema from './search-schema';
import SearchModal from './search-modal';
import SearchSchemaModal from './search-schema-modal';
import errorHandler from '../../utils/error-handler';
import Confirm from '../../componentes/message-box/confirm';
import Legenda from '../../componentes/legenda/legenda-acao';
import LoadingContainer from '../../componentes/loading-container';
import { FormattedMessage, injectIntl } from 'react-intl';
import { capitalizeFirstLetter } from '../../utils/string';
import { connect } from 'react-redux';
import ValidacaoRestricao from '../item/validacao-restricao';
import qs from 'query-string';
import { Form } from '../../utils/form';
import SearchWidget from './search-widget';
import SearchWidgetSchema from './search-widget-schema';
import css from '../../utils/css';
import LucideIcon from 'src/componentes/lucide-icon';
import HoverCard from 'src/componentes/hover-card';
import {
  allColumnsCard,
  fetchStatusDisponiveis,
  fetchCard,
  fetchStatus,
} from './kanban/components/functions';
import InputNumber from 'src/componentes/input-number';
import Button from 'src/componentes/button';
import DatePicker from 'src/componentes/date-picker';
import { parse } from 'date-fns';
import { parseDateFromUrl } from 'src/utils/parseData';
import ComentarioButton from 'src/componentes/comentarios/ComentarioButton';
import {
  buildComentarioDialogTitle,
  extractPeriodoDescricao,
} from 'src/componentes/comentarios/utils';
import Badge from 'src/componentes/Badge';

const classes = css`
  .descricao {
    text-align: left;
    background-color: #fff;
  }

  .descricaoNegrito {
    color: #0000ff;
    text-align: left;
    background-color: #fff;
    font-weight: bold;
  }
`;

@autobind
class AcaoList extends React.Component {
  static defaultProps = {
    showToolbar: true,
    usarFiltroSalvo: true,
    lang: 'en',
    kanban: true,
    atualizarAcoes: false,
  };

  constructor(props) {
    super(props);

    let objLocationSearch = {};

    if (this.props.location) {
      const query = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      });
      const keys = Object.keys(query);

      if (!(keys.length === 1 && keys[0] === 'filtroFavoritoId')) {
        objLocationSearch = query;
      }
    }

    this.state = {
      isLoadingHintAcao: false,
      arvoreHintAcao: null,
      parameters: this.props.params,
      saved: false,
      dropdownOpen: false,
      showNew: false,
      filtroAtualizado: false,
      showFilter: false,
      currentFilter: null,
      componentKey: 0,
      dataInicio: objLocationSearch.dataInicio
        ? parseDateFromUrl(objLocationSearch.dataInicio)
        : null,
      dataTermino: objLocationSearch.dataTermino
        ? parseDateFromUrl(objLocationSearch.dataTermino)
        : null,
      dataInicioPrevista: objLocationSearch.dataInicioPrevista
        ? parse(objLocationSearch.dataInicioPrevista, 'yyyy-MM-dd', new Date())
        : null,
      dataTerminoPrevista: objLocationSearch.dataTerminoPrevista
        ? parse(objLocationSearch.dataTerminoPrevista, 'yyyy-MM-dd', new Date())
        : null,
      dataInicioRealizada: objLocationSearch.dataInicioRealizada
        ? parse(objLocationSearch.dataInicioRealizada, 'yyyy-MM-dd', new Date())
        : null,
      dataTerminoRealizada: objLocationSearch.dataTerminoRealizada
        ? parse(
            objLocationSearch.dataTerminoRealizada,
            'yyyy-MM-dd',
            new Date()
          )
        : null,
      descricao: objLocationSearch.descricao
        ? objLocationSearch.descricao
        : null,
      codigo: objLocationSearch.codigo ? objLocationSearch.codigo : null,
      idFarol: objLocationSearch.farolId ? objLocationSearch.farolId : null,
      farolDescricao: objLocationSearch.farolDescricao
        ? objLocationSearch.farolDescricao
        : null,
      farolIcone: objLocationSearch.farolIcone
        ? objLocationSearch.farolIcone
        : null,
      farolCor: objLocationSearch.farolCor ? objLocationSearch.farolCor : null,
      organizacaoId: objLocationSearch.organizacaoId
        ? objLocationSearch.organizacaoId
        : null,
      areaId: objLocationSearch.areaId ? objLocationSearch.areaId : null,
      organizacaoNome: objLocationSearch.organizacaoNome
        ? objLocationSearch.organizacaoNome
        : null,
      areaNome: objLocationSearch.areaNome ? objLocationSearch.areaNome : null,
      subordinadas: objLocationSearch.subordinadas
        ? objLocationSearch.subordinadas
        : null,
      areasSubordinadas: objLocationSearch.areasSubordinadas
        ? objLocationSearch.areasSubordinadas
        : null,
      itemId: objLocationSearch.itemId ? objLocationSearch.itemId : null,
      itemNome: objLocationSearch.itemNome ? objLocationSearch.itemNome : null,
      acaoId: objLocationSearch.acaoId
        ? objLocationSearch.acaoId
        : objLocationSearch.acaoid
        ? objLocationSearch.acaoid
        : null,
      statusId: objLocationSearch.statusId ? objLocationSearch.statusId : null,
      statusNome: objLocationSearch.statusDescricao
        ? objLocationSearch.statusDescricao
        : objLocationSearch.statusNome
        ? objLocationSearch.statusNome
        : null,
      organizacaoColaboradoresId:
        location && objLocationSearch.organizacaoColaboradoresId
          ? objLocationSearch.organizacaoColaboradoresId
          : null,
      organizacaoColaboradoresNome:
        location && objLocationSearch.organizacaoColaboradoresNome
          ? objLocationSearch.organizacaoColaboradoresNome
          : null,
      responsavelId: objLocationSearch.responsavelId
        ? objLocationSearch.responsavelId
        : null,
      responsavelNome: objLocationSearch.responsavelNome
        ? objLocationSearch.responsavelNome
        : null,
      responsaveis: objLocationSearch.responsaveis
        ? JSON.parse(decodeURIComponent(objLocationSearch.responsaveis))
        : null,
      usarFiltroSalvo: objLocationSearch.usarFiltroSalvo
        ? objLocationSearch.usarFiltroSalvo === '0'
          ? false
          : true
        : true,
      acaoConfiguracao: null,
      apenasAcoesModuloAtual:
        location && objLocationSearch.apenasAcoesModuloAtual
          ? objLocationSearch.apenasAcoesModuloAtual === 'true'
            ? true
            : false
          : null,
      exibirAcoesComoMembroEquipe:
        location && objLocationSearch.exibirAcoesComoMembroEquipe
          ? objLocationSearch.exibirAcoesComoMembroEquipe === 'true'
            ? true
            : false
          : null,
      filtrarAcoesEspelho: objLocationSearch.filtrarAcoesEspelho
        ? objLocationSearch.filtrarAcoesEspelho === '1'
          ? true
          : false
        : false,
      centroCustoId: objLocationSearch.centroCustoId
        ? objLocationSearch.centroCustoId
        : null,
      centroCustoNome: objLocationSearch.centroCustoNome
        ? objLocationSearch.centroCustoNome
        : null,
      pacoteId: objLocationSearch.pacoteId ? objLocationSearch.pacoteId : null,
      pacoteNome: objLocationSearch.pacoteNome
        ? objLocationSearch.pacoteNome
        : null,
      centrosSubordinados: objLocationSearch.centrosSubordinados
        ? objLocationSearch.centrosSubordinados === 'true'
          ? true
          : false
        : false,
      pacotesSubordinados: objLocationSearch.pacotesSubordinados
        ? objLocationSearch.pacotesSubordinados === 'true'
          ? true
          : false
        : false,
      tipoOrigemId: objLocationSearch.tipoOrigemId
        ? objLocationSearch.tipoOrigemId
        : null,
      tipoOrigemDescricao: objLocationSearch.tipoOrigemDescricao
        ? objLocationSearch.tipoOrigemDescricao
        : null,
      tiposOrigemId: objLocationSearch.tiposOrigemId
        ? objLocationSearch.tiposOrigemId.split(',')
        : null,
      tiposOrigemDescricao: objLocationSearch.tiposOrigemDescricao
        ? objLocationSearch.tiposOrigemDescricao.split(',')
        : null,
      parametroUrl: null,
      somenteAcoesFilhas: objLocationSearch.somenteAcoesFilhas
        ? objLocationSearch.somenteAcoesFilhas
        : false,
      nivelAcao: objLocationSearch.nivelAcao
        ? JSON.parse(decodeURIComponent(objLocationSearch.nivelAcao))
        : null,
      allColumnsCard: [],
      allColumnsKanban: [],
      columnsCard: null,
      columnsKanban: null,
      usandoKanban: false,
      parametroSearchWidget: { farol: null },
      tipoAcaoId: objLocationSearch.tipoAcaoId
        ? objLocationSearch.tipoAcaoId
        : null,
      desdobramentoId: objLocationSearch.desdobramentoId
        ? objLocationSearch.desdobramentoId
        : null,
      desdobramentoDescricao:
        location && objLocationSearch.desdobramentoDescricao
          ? objLocationSearch.desdobramentoDescricao
          : null,
      desdobramentoSubordinados:
        location && objLocationSearch.desdobramentoSubordinados
          ? objLocationSearch.desdobramentoSubordinados
          : false,
      incluirDesdobramento: objLocationSearch.incluirDesdobramento
        ? objLocationSearch.incluirDesdobramento
        : false,
      incluirImpactosIndiretos:
        location && objLocationSearch.incluirImpactosIndiretos
          ? objLocationSearch.incluirImpactosIndiretos
          : false,
      incluirItensFormula: objLocationSearch.incluirItensFormula
        ? objLocationSearch.incluirItensFormula
        : false,
      subordinadasOrganizacaoColaboradores:
        location && objLocationSearch.subordinadasOrganizacaoColaboradores
          ? objLocationSearch.subordinadasOrganizacaoColaboradores
          : false,
      porque: null,
      updatedItems: [],
      apenasAcoesOrigem: objLocationSearch.apenasAcoesOrigem
        ? objLocationSearch.apenasAcoesOrigem === 'true'
          ? true
          : false
        : false,
      widgetDashboardIndividual:
        location && objLocationSearch.widgetDashboardIndividual
          ? objLocationSearch.widgetDashboardIndividual
          : false,
      filtrarAcoesAreaColaborador:
        location && objLocationSearch.filtrarAcoesAreaColaborador
          ? objLocationSearch.filtrarAcoesAreaColaborador
          : false,
      acoes: objLocationSearch.acoesIds
        ? (objLocationSearch.acoesIds.includes('[')
            ? JSON.parse(objLocationSearch.acoesIds)
            : objLocationSearch.acoesIds.split(',')
          ).map((x) => ({ id: Number(x) }))
        : null,
      baselineInicial: objLocationSearch.baselineInicial
        ? new Date(objLocationSearch.baselineInicial)
        : null,
      baselineTermino: objLocationSearch.baselineTermino
        ? new Date(objLocationSearch.baselineTermino)
        : null,
      matrizRiscoId: objLocationSearch.matrizRiscoId
        ? objLocationSearch.matrizRiscoId
        : null,
      matrizRiscoDescricao: objLocationSearch.matrizRiscoDescricao
        ? objLocationSearch.matrizRiscoDescricao
        : null,
      grausRiscoId: objLocationSearch.grausRiscoId
        ? objLocationSearch.grausRiscoId.split(',')
        : null,
      grausRiscoNome: objLocationSearch.grausRiscoNome
        ? objLocationSearch.grausRiscoNome.split(',')
        : null,
      auditoriaId: objLocationSearch.auditoriaId
        ? objLocationSearch.auditoriaId
        : null,
      auditoriaNome: objLocationSearch.auditoriaNome
        ? objLocationSearch.auditoriaNome
        : null,
      auditoriasId: objLocationSearch.auditoriasId
        ? objLocationSearch.auditoriasId.split(',')
        : null,
      auditoriasNome: objLocationSearch.auditoriasNome
        ? objLocationSearch.auditoriasNome.split(',')
        : null,
      csaId: objLocationSearch.csaId ? objLocationSearch.csaId : null,
      csaNome: objLocationSearch.csaNome ? objLocationSearch.csaNome : null,
      csasId: objLocationSearch.csasId
        ? objLocationSearch.csasId.split(',')
        : null,
      csasNome: objLocationSearch.csasNome
        ? objLocationSearch.csasNome.split(',')
        : null,
      pontoControleId: objLocationSearch.pontoControleId
        ? objLocationSearch.pontoControleId
        : null,
      pontoControleDescricao: objLocationSearch.pontoControleDescricao
        ? objLocationSearch.pontoControleDescricao
        : null,
      pontoControlesId: objLocationSearch.pontoControlesId
        ? objLocationSearch.pontoControlesId.split(',')
        : null,
      pontoControlesDescricao: objLocationSearch.pontoControlesDescricao
        ? objLocationSearch.pontoControlesDescricao.split(',')
        : null,
      perdaOperacionalId: objLocationSearch.perdaOperacionalId
        ? objLocationSearch.perdaOperacionalId
        : null,
      perdaOperacionalDescricao: objLocationSearch.perdaOperacionalDescricao
        ? objLocationSearch.perdaOperacionalDescricao
        : null,
      perdasOperacionaisId: objLocationSearch.perdasOperacionaisId
        ? objLocationSearch.perdasOperacionaisId.split(',')
        : null,
      perdasOperacionaisDescricao: objLocationSearch.perdasOperacionaisDescricao
        ? objLocationSearch.perdasOperacionaisDescricao.split(',')
        : null,
      camposCustomizados: objLocationSearch.camposCustomizados
        ? JSON.parse(decodeURIComponent(objLocationSearch.camposCustomizados))
        : null,
      tagsId: objLocationSearch.tagsId
        ? objLocationSearch.tagsId.split(',')
        : null,
      tagsDescricao: objLocationSearch.tagsDescricao
        ? objLocationSearch.tagsDescricao.split(',')
        : null,
      idColaboradorEquipe: objLocationSearch.idColaboradorEquipe
        ? objLocationSearch.idColaboradorEquipe
        : null,
      nomeColaboradorEquipe: objLocationSearch.nomeColaboradorEquipe
        ? objLocationSearch.nomeColaboradorEquipe
        : null,
      entidadeIdOpenModal: objLocationSearch.entidadeIdOpenModal
        ? objLocationSearch.entidadeIdOpenModal
        : null,
      ocultarStatusArquivado: objLocationSearch.ocultarStatusArquivado
        ? objLocationSearch.ocultarStatusArquivado
        : false,
    };

    this.form = new Form({ component: this, schema: SearchSchema });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      this.props.apenasAcoesModuloAtual &&
      newProps.parameters.apenasAcoesModuloAtual
    ) {
      if (
        newProps.parameters.apenasAcoesModuloAtual !==
        this.props.apenasAcoesModuloAtual
      ) {
        this.setState(
          {
            apenasAcoesModuloAtual: newProps.parameters.apenasAcoesModuloAtual,
          },
          this.refresh
        );
      }
    }

    if (this.props.apenasAcoesOrigem && newProps.parameters.apenasAcoesOrigem) {
      if (
        newProps.parameters.apenasAcoesOrigem !== this.props.apenasAcoesOrigem
      ) {
        this.setState(
          { apenasAcoesOrigem: newProps.parameters.apenasAcoesOrigem },
          this.refresh
        );
      }
    }
  }

  componentDidMount() {
    if (this.props.params) {
      if (this.props.params.tipoItem && this.props.params.tipoItem === '3') {
        http
          .post(`/ItemConfiguracaoObjetivo/ObterConfiguracoes`, {
            parameters: this.props.parameters,
          })
          .then((response) => {
            if (response.data !== null) {
              this.setState({
                showNew: response.data.permitirCadastrarAcoes,
              });
            }
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    }
    if (!this.props.showModal) {
      this.atualizarParametros();
    }
    this.obterConfiguracoes();
  }
  async getAllInfos(configurations) {
    let allColumnsCardLocal = allColumnsCard(
      this.props.intl,
      this.props.resources,
      configurations
    );
    let columnsCard = await fetchCard(allColumnsCardLocal, this.props.viewType);
    let allColumnsKanban = await fetchStatusDisponiveis(this.props.viewType);
    let columnsKanban = await fetchStatus(
      allColumnsKanban,
      this.props.viewType
    );

    this.setState({
      acaoConfiguracao: configurations,
      allColumnsCard: allColumnsCardLocal,
      columnsCard: columnsCard,
      allColumnsKanban: allColumnsKanban,
      columnsKanban: columnsKanban,
    });
  }

  async obterConfiguracoes() {
    if (this.props.configurations) {
      await this.getAllInfos(this.props.configurations);
      return;
    }

    http
      .post(`/AcaoConfiguracao/ObterConfiguracoes`, {})
      .then(async (response) => {
        await this.getAllInfos(response.data.model);
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  handleDesassociarClick(item) {
    http
      .post(`/Acao/DesassociarAcao`, {
        acao: item,
      })
      .then(() => {
        this.setState({
          saved: Math.random(),
        });
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  handleRemoveAcoes() {
    ContentManager.addContent(
      <Confirm
        message={
          <FormattedMessage id="label.desejaMesmoExcluirTodosOsRegistros" />
        }
        handleConfirm={this.removeTodasAcoes}
      />
    );
  }

  removeTodasAcoes() {
    http
      .post(`/Acao/ExcluirTodasAcoes`, {
        itemId: this.props.params.itemId,
      })
      .then(() => {
        this.setState({
          saved: Math.random(),
        });
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  handleOpenGantt() {
    history.push({
      pathname: '/gerenciar/gantt',
      search: `?itemId=${this.props.params.itemId}`,
    });
  }

  handleHintAcao(acoes, acaoId, acao) {
    if (acao && acao.id <= 0) {
      return (
        <tr key={acao.id}>
          <td
            className={
              acao.id == acaoId ? classes.descricaoNegrito : classes.descricao
            }
            style={{ background: '#ffffff' }}
          >
            <span>
              <div
                style={{
                  verticalAlign: 'middle',
                  paddingLeft: acao.level * 20,
                }}
              >
                {acao.codigo != null
                  ? acao.codigo + '-' + acao.descricao
                  : acao.descricao}
              </div>
            </span>
          </td>
        </tr>
      );
    }

    return acoes.data.itens.map((acao, index) => (
      <tr key={index * 2}>
        <td
          className={
            acao.id == acaoId ? classes.descricaoNegrito : classes.descricao
          }
          style={{ background: '#ffffff' }}
        >
          <span>
            <div
              style={{
                verticalAlign: 'middle',
                paddingLeft: acao.level * 20,
              }}
            >
              {acao.codigo != null
                ? acao.codigo + '-' + acao.descricao
                : acao.descricao}
            </div>
          </span>
        </td>
      </tr>
    ));
  }

  async carregarHintAcao(acao, open) {
    if (!open) return;

    this.setState({ isLoadingHintAcao: true });

    try {
      var retorno = await http.post(`/Acao/ObterHintAcoes`, {
        itemNome: acao.nomeItem,
        acaoId: acao.id,
        acaoDescricao: acao.descricao,
      });

      this.setState({ arvoreHintAcao: retorno, isLoadingHintAcao: false });
    } catch (error) {
      errorHandler(error);
      this.setState({
        isLoadingHintAcao: false,
      });
    }
  }

  handlePlanoAcaoClick(item) {
    let url = `?itemId=`;

    if (item.item.desdobramento != null) {
      url += `${item.item.id}&desdobramentoId=${item.item.desdobramento.id}`;
    } else {
      url += `${item.item.id}`;
    }

    history.push({
      pathname: '/gerenciar/gantt',
      search: url,
    });
  }

  renderDescricao(item, callback) {
    if (!item.descricao) {
      return;
    }
    return (
      <HoverCard
        placement="right"
        className="tw:w-150"
        onOpenChange={(open) => this.carregarHintAcao(item, open)}
        content={
          <LoadingContainer isLoading={this.state.isLoadingHintAcao}>
            {this.state.arvoreHintAcao && (
              <table>
                <tbody>
                  {this.handleHintAcao(
                    this.state.arvoreHintAcao,
                    item.id,
                    item
                  )}
                </tbody>
              </table>
            )}
          </LoadingContainer>
        }
      >
        <div>
          {this.props.isConsultaExterna ? (
            <span>{item.descricao}</span>
          ) : (
            <a
              tabIndex="-1"
              onClick={this.handleDescricaoClick.bind(this, item, callback)}
              style={{ cursor: 'pointer' }}
            >
              {item.descricao}
            </a>
          )}
        </div>
      </HoverCard>
    );
  }

  handleDescricaoClick(item) {
    ContentManager.addContent(
      <AcaoEdit
        defaultActiveKey={0}
        showExport
        handleClose={this.handleCloseEdit}
        item={item}
        parameters={{
          exibirLookups: true,
          ...this.state.parameters,
          ...this.props.parameters,
        }}
        onDeleting={this.handleDeleteClick}
        {...this.props}
      />
    );
  }

  handleCloseEdit(saved) {
    if (saved) {
      this.props.refreshCount && this.props.refreshCount(saved);
      this.setState({ saved: Math.random() });
    }
  }

  handleFilterDrawer = () => {
    this.setState({ showFilter: true });
  };

  closeFilter = () => {
    this.setState({ showFilter: false, currentFilter: null });
  };

  handleFiltrar = (filter) => {
    this.setState({ currentFilter: filter, saved: Math.random() });
    this.closeFilter();
  };

  renderResponsavel(item) {
    return <span>{item.responsavel ? item.responsavel.nome : ''}</span>;
  }

  renderStatus(item) {
    if (!item.status) return;

    return (
      <Badge
        pill
        style={{ color: item.status.cor, background: item.status.corFundo }}
      >
        {item.status.descricao}
      </Badge>
    );
  }

  renderTipoOrigem(item, intl) {
    let tipoOrigem = null;

    if (item.tipoOrigem === 'reuniao')
      tipoOrigem = <FormattedMessage id="reuniao" />;
    else if (item.tipoOrigem === 'auditoria')
      tipoOrigem = this.props.resources.auditoria;
    else if (item.tipoOrigem === 'auditoriaChecklist')
      tipoOrigem = intl.formatMessage(
        { id: 'titulo.auditoriaChecklist' },
        { auditoria: this.props.resources.auditoria }
      );
    else if (item.tipoOrigem === 'controlSelfAssessment')
      tipoOrigem = intl.formatMessage({
        id: 'labelControlSelfAssessment',
      });
    else if (item.tipoOrigem === 'pontoDeControle')
      tipoOrigem = this.props.resources.pontodecontrole;
    else if (item.tipoOrigem === 'perdaOperacional')
      tipoOrigem = this.props.resources.perdaoperacional;
    else if (item.tipoOrigem === 'labelPesquisaClima')
      tipoOrigem = capitalizeFirstLetter(this.props.resources.pesquisa);
    else if (item.pacote != null || item.centroCusto != null)
      tipoOrigem = capitalizeFirstLetter(this.props.resources.orcamento);
    else
      tipoOrigem = capitalizeFirstLetter(this.props.resources[item.tipoOrigem]);

    return <span>{tipoOrigem}</span>;
  }

  renderTipoAcao(item) {
    if (item.tipoAcao == 1) {
      return <FormattedMessage id="preventiva" />;
    } else if (item.tipoAcao == 2) {
      return <FormattedMessage id="corretiva" />;
    }
  }

  renderDataTerminoPrevista(item) {
    if (!item.dataTerminoPrevista) return;

    return (
      <span>
        {moment(item.dataTerminoPrevista).locale(this.props.lang).format('L')}
      </span>
    );
  }

  renderDataInicioPrevista(item) {
    if (!item.dataInicioPrevista) return;

    return (
      <span>
        {moment(item.dataInicioPrevista).locale(this.props.lang).format('L')}
      </span>
    );
  }

  renderDataTerminoRealizada(item) {
    const disabled = item.possuiFilhos || item.possuiAcaoOrigem;
    const allowEdit = item?.permissions?.allowEdit;

    if (this.props.atualizarAcoes && allowEdit) {
      return (
        <DatePicker
          placement="bottom"
          style={{ marginTop: 10, textAlign: 'center' }}
          timeFormat={false}
          autoFormatDate={true}
          model={{
            label: '',
            value: item.dataTerminoRealizada,
            requestChange: (value) =>
              this.handleChangeItem(item, 'dataTerminoRealizada', value),
          }}
          disabled={
            disabled || !item.podeEditarPercentualRealizadoEDatasRealizadas
          }
        />
      );
    } else {
      if (!item.dataTerminoRealizada) return;
      else {
        return (
          <span>
            {moment(item.dataTerminoRealizada)
              .locale(this.props.lang)
              .format('L')}
          </span>
        );
      }
    }
  }

  renderDataInicioRealizada(item) {
    const disabled = item.possuiFilhos || item.possuiAcaoOrigem;
    const allowEdit = item?.permissions?.allowEdit;

    if (this.props.atualizarAcoes && allowEdit) {
      return (
        <DatePicker
          placement="bottom"
          style={{ marginTop: 10, textAlign: 'center' }}
          timeFormat={false}
          autoFormatDate={true}
          model={{
            label: '',
            value: item.dataInicioRealizada,
            requestChange: (value) =>
              this.handleChangeItem(item, 'dataInicioRealizada', value),
          }}
          disabled={
            disabled || !item.podeEditarPercentualRealizadoEDatasRealizadas
          }
        />
      );
    } else {
      if (!item.dataInicioRealizada) return;
      else {
        return (
          <span>
            {moment(item.dataInicioRealizada)
              .locale(this.props.lang)
              .format('L')}
          </span>
        );
      }
    }
  }

  renderFarol(item) {
    return (
      <span>
        {item.farolAcao && (
          <span
            title={item.farolAcao.descricao}
            className="list-title-item list-item-comum"
          >
            <SvgIcon
              id={'acaoFarolid' + item.id}
              icon={item.farolAcao.icone}
              color={item.farolAcao.cor}
              colorHover={item.farolAcao.cor}
              size={item.farolAcao.tamanho}
              title={item.farolAcao.descricao}
            ></SvgIcon>
          </span>
        )}
      </span>
    );
  }

  renderCentroCusto(item) {
    return item.centroCusto && <a>{item.centroCusto.nome}</a>;
  }

  renderPacote(item) {
    return item.pacote && <a>{item.pacote.nome}</a>;
  }

  handleDeleteClick(item) {
    if (item.id > 0) {
      ContentManager.addContent(
        <ValidacaoRestricao
          url="/Acao/ValidarRestricoes"
          urlExclusao="/Acao/AtualizarStatusExcluido"
          item={item}
          afterRemove={this.props.afterRemove}
          onClose={this.handleCloseEdit}
        />
      );
    } else {
      this.props.afterRemove && this.props.afterRemove(item);
      this.handleCloseEdit();
    }
  }

  ehApresentacaoComFiltroConfigurado() {
    return !!(this.props.urlApresentacao && this.props.selectedFilter);
  }

  atualizarParametros() {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const keys = Object.keys(query);

    if (
      location.search &&
      !(keys.length === 1 && keys[0] === 'filtroFavoritoId')
    ) {
      this.setState({
        parametroUrl: {
          dataInicioPrevista: this.state.dataInicioPrevista
            ? this.state.dataInicioPrevista
            : this.state.dataInicio
            ? this.state.dataInicio
            : null,
          dataTerminoPrevista: this.state.dataTerminoPrevista
            ? this.state.dataTerminoPrevista
            : this.state.dataTermino
            ? this.state.dataTermino
            : null,
          dataInicioRealizada: this.state.dataInicioRealizada,
          dataTerminoRealizada: this.state.dataTerminoRealizada,
          codigo: this.state.codigo,
          descricao: this.state.descricao,
          farol: this.state.idFarol
            ? [
                {
                  id: this.state.idFarol,
                  descricao: this.state.farolDescricao,
                  icone: this.state.farolIcone,
                  cor: this.state.farolCor,
                },
              ]
            : null,
          areas: this.state.organizacaoId
            ? [
                {
                  id: this.state.organizacaoId,
                  nome: this.state.organizacaoNome,
                },
              ]
            : this.state.areaId
            ? [
                {
                  id: this.state.areaId,
                  nome: this.state.areaNome,
                },
              ]
            : null,
          areaSubordinada: this.state.subordinadas
            ? this.state.subordinadas
            : this.state.areasSubordinadas
            ? this.state.areasSubordinadas
            : false,
          itens: this.state.itemId
            ? [
                {
                  id: this.state.itemId,
                  nome: this.state.itemNome,
                },
              ]
            : null,
          listaStatus: this.state.statusId
            ? [
                {
                  id: this.state.statusId,
                  descricao: this.state.statusNome,
                },
              ]
            : null,
          responsaveis: this.state.responsaveis
            ? this.state.responsaveis
            : this.state.responsavelId
            ? [
                {
                  id: this.state.responsavelId,
                  nome: this.state.responsavelNome,
                  descricao: this.state.responsavelNome,
                },
              ]
            : null,
          apenasAcoesModuloAtual: this.state.apenasAcoesModuloAtual
            ? this.state.apenasAcoesModuloAtual
            : false,
          exibirAcoesComoMembroEquipe: this.state.exibirAcoesComoMembroEquipe
            ? this.state.exibirAcoesComoMembroEquipe
            : false,
          widgetDashboardIndividual: this.state.widgetDashboardIndividual
            ? this.state.widgetDashboardIndividual
            : false,
          filtrarAcoesAreaColaborador: this.state.filtrarAcoesAreaColaborador
            ? this.state.filtrarAcoesAreaColaborador
            : false,
          filtrarAcoesEspelho: this.state.filtrarAcoesEspelho,
          centroCusto: this.state.centroCustoId
            ? { id: this.state.centroCustoId, nome: this.state.centroCustoNome }
            : null,
          pacote: this.state.pacoteId
            ? { id: this.state.pacoteId, nome: this.state.pacoteNome }
            : null,
          centrosSubordinados: this.state.centrosSubordinados
            ? this.state.centrosSubordinados
            : false,
          pacotesSubordinados: this.state.pacotesSubordinados
            ? this.state.pacotesSubordinados
            : false,
          tipoOrigem: this.state.tipoOrigemId
            ? {
                id: this.state.tipoOrigemId,
                descricao: this.state.tipoOrigemDescricao,
              }
            : null,
          tiposOrigem: this.state.tiposOrigemId
            ? this.state.tiposOrigemId.map((id, index) => {
                return {
                  id: this.state.tiposOrigemId[index],
                  descricao: this.state.tiposOrigemDescricao[index],
                };
              })
            : null,
          //organizacaoColaboradoresId: this.state.organizacaoColaboradoresId
          areaColaboradores: this.state.organizacaoColaboradoresId
            ? {
                id: this.state.organizacaoColaboradoresId,
                nome: this.state.organizacaoColaboradoresNome,
              }
            : null,
          tipoAcao: this.state.tipoAcaoId
            ? { id: this.state.tipoAcaoId }
            : null,
          desdobramento: this.state.desdobramentoId
            ? {
                id: this.state.desdobramentoId,
                descricao: this.state.desdobramentoDescricao,
              }
            : null,
          desdobramentoSubordinados: this.state.desdobramentoSubordinados
            ? this.state.desdobramentoSubordinados
            : false,
          incluirDesdobramento: this.state.incluirDesdobramento
            ? this.state.incluirDesdobramento
            : false,
          incluirImpactosIndiretos: this.state.incluirImpactosIndiretos
            ? this.state.incluirImpactosIndiretos
            : false,
          incluirItensFormula: this.state.incluirItensFormula
            ? this.state.incluirItensFormula
            : false,
          AreaSubordinadaColaboradores: this.state
            .subordinadasOrganizacaoColaboradores
            ? this.state.subordinadasOrganizacaoColaboradores
            : false,
          porque: this.state.porque,
          apenasAcoesOrigem: this.state.apenasAcoesOrigem
            ? this.state.apenasAcoesOrigem
            : false,
          nivelAcao: this.state.nivelAcao ? this.state.nivelAcao : null,
          matrizRisco: this.state.matrizRiscoId
            ? {
                id: this.state.matrizRiscoId,
                descricao: this.state.matrizRiscoDescricao,
              }
            : null,
          grausRisco: this.state.grausRiscoId
            ? this.state.grausRiscoId.map((id, index) => {
                return {
                  id: this.state.grausRiscoId[index],
                  descricao: this.state.grausRiscoNome[index],
                };
              })
            : null,
          auditorias: this.state.auditoriaId
            ? [{ id: this.state.auditoriaId, nome: this.state.auditoriaNome }]
            : this.state.auditoriasId
            ? this.state.auditoriasId.map((id, index) => {
                return {
                  id: this.state.auditoriasId[index],
                  nome: this.state.auditoriasNome[index],
                };
              })
            : null,
          controlSelfAssessments: this.state.csaId
            ? [{ id: this.state.csaId, nome: this.state.csaNome }]
            : this.state.csasId
            ? this.state.csasId.map((id, index) => {
                return {
                  id: this.state.csasId[index],
                  nome: this.state.csasNome[index],
                };
              })
            : null,
          pontosDeControle: this.state.pontoControleId
            ? [
                {
                  id: this.state.pontoControleId,
                  descricao: this.state.pontoControleDescricao,
                },
              ]
            : this.state.pontoControlesId
            ? this.state.pontoControlesId.map((id, index) => {
                return {
                  id: this.state.pontoControlesId[index],
                  descricao: this.state.pontoControlesDescricao[index],
                };
              })
            : null,
          perdasOperacionais: this.state.perdaOperacionalId
            ? [
                {
                  id: this.state.perdaOperacionalId,
                  descricao: this.state.perdaOperacionalDescricao,
                },
              ]
            : this.state.perdasOperacionaisId
            ? this.state.perdasOperacionaisId.map((id, index) => {
                return {
                  id: this.state.perdasOperacionaisId[index],
                  descricao: this.state.perdasOperacionaisDescricao[index],
                };
              })
            : null,
          camposCustomizados: this.state.camposCustomizados
            ? this.state.camposCustomizados
            : null,
          tags: this.state.tagsId
            ? this.state.tagsId.map((id, index) => {
                return {
                  id: this.state.tagsId[index],
                  descricao: this.state.tagsDescricao[index],
                };
              })
            : null,
          equipe: this.state.idColaboradorEquipe
            ? [
                {
                  id: this.state.idColaboradorEquipe,
                  nome: this.state.nomeColaboradorEquipe,
                },
              ]
            : null,
          ocultarStatusArquivado: this.state.ocultarStatusArquivado
            ? this.state.ocultarStatusArquivado
            : false,
        },
      });
      let parametros = this.state.parametroUrl;
      return parametros;
    }
  }

  usandoKanban(usando) {
    this.setState({
      usandoKanban: usando,
    });
  }

  renderChecklist(item) {
    if (item.tarefas) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LucideIcon
            style={{ marginTop: 3, marginRight: 5 }}
            icon="checkbox-marked-outline"
          />
          {item.tarefas &&
            item.tarefas.filter((a) => a.concluida == true).length}
          /{item.tarefas && item.tarefas.length}
        </div>
      );
    }
  }

  updateParams(search) {
    let { params } = this.props;

    let parameters = {
      ...params,
      ...search,
      statusId: search.status ? search.status.id : null,
      listaStatus: search.listaStatus ? search.listaStatus : null,
      // responsavelId:
      //   search.responsaveis && search.responsaveis[0]
      //     ? search.responsaveis[0].id
      //     : null,
      itemId:
        !this.props.filtroLocal && search.item
          ? search.item.id
          : this.props.parameters?.itemId,
      item: search.item ? search.item : null,
      //tipoOrigemId: search.tipoOrigem ? search.tipoOrigem.id : null,
      farol: search.farol ? search.farol : null,
      areasSubordinadas: search.areaSubordinada,
      tipoItemId: this.props.parameters?.tipoItemId,
      filtrarAcoesEspelho:
        this.props.parameters && this.props.parameters.filtrarAcoesVinculadas
          ? true
          : search.filtrarAcoesEspelho,
      itemIdIgnorar: this.props.parameters?.itemIdIgnorar,
    };

    this.setState({ filtroAtualizado: true, defaultFilter: parameters });
    return parameters;
  }

  renderPontosProblematicos(item) {
    if (item.pontosProblematicos) {
      let descricaoPonto = '';
      item.pontosProblematicos.map(
        (ponto) => (descricaoPonto += ponto.descricao + '; ')
      );

      return (
        <div style={{ display: 'flex', alignItems: 'left' }}>
          {descricaoPonto}
        </div>
      );
    }
  }

  renderPercentualRealizado(item) {
    const disabled = item.possuiFilhos || item.possuiAcaoOrigem;

    return (
      <InputNumber
        style={{ marginTop: 10, textAlign: 'center' }}
        precision={2}
        disabled={
          !item ||
          !this.state.acaoConfiguracao.utilizarPercentualRealizado ||
          disabled ||
          !item.podeEditarPercentualRealizadoEDatasRealizadas
        }
        model={{
          value: item.percentualRealizado,
          requestChange: (value) =>
            this.handleChangeItem(item, 'percentualRealizado', value),
        }}
      />
    );
  }

  setNewUpdatedItem = (item) => {
    if (!item) return;

    let newArray = [...this.state.updatedItems];
    let currentIndex = newArray.findIndex((i) => i.id === item.id);
    if (currentIndex < 0) {
      newArray.push(item);
    } else {
      newArray[currentIndex] = item;
    }
    this.setState({ updatedItems: newArray });
  };

  handleChangeItem = async (item, field, valor) => {
    try {
      item[field] = valor;

      item.editado = true;
      this.setNewUpdatedItem(item);
    } catch (err) {
      errorHandler(err);
    }
  };

  handleSaveClick = async () => {
    await http
      .post(`Acao/SalvarAcoes`, {
        model: this.state.updatedItems,
      })
      .then(() => {
        this.setState({
          updatedItems: [],
          saved: Math.random(),
        });
      })
      .catch((err) => {
        errorHandler(err);
      });
  };

  renderCreator(item) {
    if (!item.criadorAcao) return;

    return <span>{item.criadorAcao.nome}</span>;
  }

  renderCreationDate(item) {
    if (!item.dataCriacaoAcao) return;

    return (
      <span>
        {moment(item.dataCriacaoAcao).locale(this.props.lang).format('L')}
      </span>
    );
  }

  handleComentarioChange() {
    this.setState({
      componentKey: this.state.componentKey + 1,
    });
  }

  getComentarioDialogTitle(item) {
    const { intl } = this.props;
    const nome = item?.descricao ?? item?.nome;
    const periodo = extractPeriodoDescricao(item);

    return buildComentarioDialogTitle(intl, nome, periodo);
  }

  renderComentarios(item) {
    return (
      <ComentarioButton
        item={item}
        tipoEntidade={7}
        dialogTitle={this.getComentarioDialogTitle(item)}
        onCountChange={this.handleComentarioChange}
        key={this.state.componentKey}
        entidadeIdOpenModal={this.state.entidadeIdOpenModal}
      />
    );
  }

  handleNewClick(isAcaoAprovacao) {
    ContentManager.addContent(
      <AcaoEdit
        mode="edit"
        parameters={{
          exibirLookups: true,
          ...this.state.parameters,
          ...this.props.parameters,
        }}
        endpoint={isAcaoAprovacao ? '/AcaoAprovacao' : '/Acao'}
        handleClose={
          isAcaoAprovacao
            ? () =>
                history.push({
                  pathname: '/gerenciar/acao',
                  search: `tab=1`,
                })
            : this.handleCloseEdit
        }
        isAcaoAprovacao={isAcaoAprovacao}
        onVincularAcaoSuccess={this.props.onVincularAcaoSuccess}
      />
    );
  }

  renderNewButton() {
    return (
      <UncontrolledButtonDropdown>
        <Button
          onClick={() => this.handleNewClick()}
          id="caret"
          leftIcon="plus"
        >
          {capitalizeFirstLetter(this.props.resources.acao)}
        </Button>
        {this.state.acaoConfiguracao?.utilizarAprovacaoAcoes && (
          <>
            <DropdownToggle color="primary" split />
            <DropdownMenu>
              <DropdownItem onClick={() => this.handleNewClick(true)}>
                {capitalizeFirstLetter(
                  this.props.intl.formatMessage(
                    { id: 'acaoParaAprovar' },
                    { acao: this.props.resources.acao }
                  )
                )}
              </DropdownItem>
            </DropdownMenu>
          </>
        )}
      </UncontrolledButtonDropdown>
    );
  }

  renderBaselineInicial(item) {
    if (!item.baselineInicial) return;

    return (
      <span>
        {moment(item.baselineInicial).locale(this.props.lang).format('L')}
      </span>
    );
  }

  renderBaselineTermino(item) {
    if (!item.baselineTermino) return;

    return (
      <span>
        {moment(item.baselineTermino).locale(this.props.lang).format('L')}
      </span>
    );
  }

  renderTags(item) {
    return item.tags?.map((x, index) => (
      <Badge
        key={x.id ?? `${x.descricao}-${index}`}
        pill
        className="text-white"
        style={{ background: x.cor }}
      >
        {x.descricao}
      </Badge>
    ));
  }

  renderEquipe(item) {
    if (item.equipe) {
      const nomes = item.equipe.map(function (colaborador) {
        return colaborador.nome;
      });

      return <span>{nomes.join('; ')}</span>;
    }
  }

  renderGrauRisco(grauRisco, inerente, item) {
    if (!(grauRisco && grauRisco.cor)) return;
    const grau = (
      <div className=" text-center">
        {grauRisco && grauRisco.cor && (
          <div>
            <LucideIcon
              icon="circle"
              color={grauRisco.cor}
              colorHover={grauRisco.cor}
              size={22}
            />
            {item.avaliacaoPendente && (
              <strong style={{ color: grauRisco.cor }} color={grauRisco.cor}>
                !
              </strong>
            )}
          </div>
        )}
      </div>
    );

    if (!item.avaliacaoPendente) return grau;

    return (
      <HoverCard
        className="tw:w-75"
        content={
          <strong>
            {this.props.intl.formatMessage(
              { id: 'haAvaliacoesRiscoAtrasadas' },
              { risco: this.props.resources.risco }
            )}
          </strong>
        }
      >
        {grau}
      </HoverCard>
    );
  }

  renderDescricaoGrauRisco(item, field = 'descricaoGrauRisco') {
    return item ? (
      <div className=" text-center">{item[field]}</div>
    ) : (
      <div></div>
    );
  }

  renderStatusBaseLine(item) {
    if (!item.statusBaseLine) return;

    return <span>{item.statusBaseLine.descricao}</span>;
  }

  render() {
    let {
      params,
      resources,
      intl,
      disabled = false,
      showModal,
      moduloAtual,
      filtroId = 5,
      user,
      showToolbar,
      urlApresentacao,
      showSearchWidget,
      hideSearch = false,
      usarFiltroSalvo,
      showSearchAtualizarAcao,
      filtroLocal,
      parameters,
      atualizarAcoes,
      isConsultaExterna,
      showExport = true,
      endpoint: endpointProp = '/Acao',
      configuracaoSistema,
      search = <Search />,
      searchSchema = SearchSchema,
    } = this.props;

    const endpoint =
      configuracaoSistema?.utilizarNovaListagemAcoes && endpointProp === '/Acao'
        ? '/AcaoListagem'
        : endpointProp;

    let { parametroUrl, parametroSearchWidget } = this.state;
    let moduloLicenca = user.licenca.modulos.find((i) => {
      return i.ativo && i.id === 2;
    });

    if (moduloLicenca === undefined) {
      moduloLicenca = false;
    } else {
      moduloLicenca = true;
    }

    let createChildItems = [
      {
        label: capitalizeFirstLetter(resources.planodeacao),
        icon: 'ChartNoAxesGantt',
        visible: (item) => item.item != null,
        onClick: this.handlePlanoAcaoClick,
      },
    ];

    let actions = [];
    if (this.props.params && this.props.params.itemId) {
      actions.concat(
        <DropdownItem onClick={this.handleOpenGantt}>
          <FormattedMessage id="label.gantt" />
        </DropdownItem>
      );
      actions.concat(
        <DropdownItem onClick={this.handleRemoveAcoes}>
          <FormattedMessage
            id="label.deletarTodoPlano"
            values={{ planodeacao: resources.planodeacao }}
          />
        </DropdownItem>
      );
    }

    const actionsToolBar = atualizarAcoes
      ? [
          <Button
            key={1}
            className="ml-2"
            onClick={this.handleSaveClick}
            type="primary"
            toolbar
            icon="content-save-outline"
          >
            {this.state.updatedItems.length > 0 && (
              <span className="ml-2">{this.state.updatedItems.length}</span>
            )}
          </Button>,
        ]
      : [];

    const possuiParametrosUrl =
      (this.state.responsavelId &&
        this.state.responsavelNome &&
        this.state.responsavelNome.length > 0) ||
      (this.state.responsaveis && this.state.responsaveis.length > 0) ||
      this.state.dataInicio ||
      this.state.dataTermino ||
      this.state.dataInicioPrevista ||
      this.state.dataTerminoPrevista ||
      this.state.dataInicioRealizada ||
      this.state.dataTerminoRealizada ||
      this.state.descricao ||
      this.state.codigo ||
      this.state.idFarol ||
      this.state.farolDescricao ||
      this.state.farolIcone ||
      this.state.farolCor ||
      this.state.organizacaoId ||
      this.state.organizacaoNome ||
      this.state.areaId ||
      this.state.areaNome ||
      this.state.subordinadas ||
      this.state.areasSubordinadas;
    this.state.itemId ||
      this.state.itemNome ||
      this.state.acaoId ||
      this.state.statusId ||
      this.state.statusNome ||
      this.state.organizacaoColaboradoresId ||
      this.state.organizacaoColaboradoresNome ||
      //this.state.usarFiltroSalvo ||
      this.state.apenasAcoesModuloAtual ||
      this.state.exibirAcoesComoMembroEquipe ||
      this.state.filtrarAcoesEspelho ||
      this.state.centroCustoId ||
      this.state.centroCustoNome ||
      this.state.pacoteId ||
      this.state.pacoteNome ||
      this.state.centrosSubordinados ||
      this.state.pacotesSubordinados ||
      this.state.tipoOrigemId ||
      this.state.tipoOrigemDescricao ||
      this.state.tiposOrigemId ||
      this.state.tiposOrigemDescricao ||
      this.state.somenteAcoesFilhas ||
      this.state.nivelAcao ||
      this.state.tipoAcaoId ||
      this.state.desdobramentoId ||
      this.state.desdobramentoDescricao ||
      this.state.desdobramentoSubordinados ||
      this.state.incluirDesdobramento ||
      this.state.incluirImpactosIndiretos ||
      this.state.incluirItensFormula ||
      this.state.subordinadasOrganizacaoColaboradores ||
      this.state.apenasAcoesOrigem ||
      this.state.widgetDashboardIndividual ||
      this.state.filtrarAcoesAreaColaborador ||
      this.state.acoes ||
      this.state.baselineInicial ||
      this.state.baselineTermino ||
      this.state.matrizRiscoId ||
      this.state.matrizRiscoDescricao ||
      this.state.grausRiscoId ||
      this.state.grausRiscoNome ||
      this.state.auditoriaId ||
      this.state.auditoriaNome ||
      this.state.auditoriasId ||
      this.state.auditoriasNome ||
      this.state.csaId ||
      this.state.csaNome ||
      this.state.csasId ||
      this.state.csasNome ||
      this.state.pontoControleId ||
      this.state.pontoControleDescricao ||
      this.state.pontoControlesId ||
      this.state.pontoControlesDescricao ||
      this.state.perdaOperacionalId ||
      this.state.perdaOperacionalDescricao ||
      this.state.perdasOperacionaisId ||
      this.state.perdasOperacionaisDescricao ||
      this.state.camposCustomizados ||
      this.state.tagsId ||
      this.state.tagsDescricao ||
      this.state.idColaboradorEquipe ||
      this.state.nomeColaboradorEquipe ||
      this.state.ocultarStatusArquivado;

    return (
      <div>
        {this.state.acaoConfiguracao != null && (
          <List
            usandoKanban={this.usandoKanban}
            kanban={this.props.kanban}
            exportApresentacao={this.props.exportApresentacao}
            formatoKanbanDefault={
              this.state.acaoConfiguracao.formatoKanbanDefault
            }
            usarIdCampCustomizado={true}
            columnsCard={this.state.columnsCard}
            columnsKanban={this.state.columnsKanban}
            allColumnsCard={this.state.allColumnsCard}
            allColumnsKanban={this.state.allColumnsKanban}
            handleDescricaoClick={this.handleDescricaoClick}
            showNew={!isConsultaExterna && !disabled}
            createChildItems={
              moduloAtual.id === 1 || moduloAtual.id === 7
                ? createChildItems
                : null
            }
            showRecurso={moduloAtual.id === 7}
            modelValue={
              urlApresentacao
                ? null
                : showSearchWidget
                ? parametroSearchWidget
                : parametroUrl
            }
            url={endpoint}
            editComponent={AcaoEdit}
            sort="UltimaVersao.CodigoOrdenacao"
            showDetail
            pageSize={20}
            tag={showModal ? 2013 : 2005}
            searchModel={{
              item: { id: this.state.itemId, nome: this.state.itemNome },
            }}
            onRemoveSaveFilter={true}
            filterDrawer={true}
            enableSearch={true}
            onSearch={this.handleFiltrar}
            {...this.props}
            preventRemoveFilterChip={this.ehApresentacaoComFiltroConfigurado}
            parameters={
              parameters != null && parameters.isGanttSearch
                ? {
                    item: this.props.parameters?.itemId
                      ? { id: this.props.parameters?.itemId }
                      : null,
                    centroCusto: this.props.parameters?.centroCustoId
                      ? { id: this.props.parameters?.centroCustoId }
                      : null,
                    pacote: this.props.parameters?.pacoteId
                      ? { id: this.props.parameters?.pacoteId }
                      : null,
                    desdobramento: this.state.desdobramentoId
                      ? { id: this.state.desdobramentoId }
                      : null,
                    acao: this.state.acaoId ? { id: this.state.acaoId } : null,
                    itemId: this.props.parameters?.itemId,
                    centroCustoId: this.props.parameters?.centroCustoId,
                    pacoteId: this.props.parameters?.pacoteId,
                    desdobramentoId: this.state.desdobramentoId,
                    acaoId: this.state.acaoId,
                    naoFiltrarAcoesProjetosFilhos: true,
                    tipoItemId: this.props.parameters?.tipoItemId,
                  }
                : {
                    ...params,
                    ...parameters,
                    tipoItemId: this.props.parameters?.tipoItemId,
                    itemId: this.props.parameters?.itemId,
                    apenasAcoesModuloAtual: this.state.apenasAcoesModuloAtual,
                    exibirAcoesComoMembroEquipe:
                      this.state.exibirAcoesComoMembroEquipe,
                    widgetDashboardIndividual:
                      this.state.widgetDashboardIndividual,
                    filtrarAcoesAreaColaborador:
                      this.state.filtrarAcoesAreaColaborador,
                    filtrarAcoesEspelho:
                      this.props.parameters &&
                      this.props.parameters.filtrarAcoesVinculadas
                        ? true
                        : this.state.filtrarAcoesEspelho,
                    idFarol: this.state.idFarol,
                    farol: this.state.idFarol
                      ? [
                          {
                            id: this.state.idFarol,
                            descricao: this.state.farolDescricao,
                            icone: this.state.farolIcone,
                            cor: this.state.farolCor,
                          },
                        ]
                      : null,
                    areaId:
                      this.state.organizacaoId ?? (params && params.areaId),
                    areasSubordinadas:
                      this.state.subordinadas ??
                      params?.areasSubordinadas ??
                      false,
                    item:
                      this.state.itemId &&
                      (!parameters ||
                        !parameters.itemIdIgnorar ||
                        this.state.itemId != parameters.itemIdIgnorar)
                        ? { id: this.state.itemId, nome: this.state.itemNome }
                        : params?.itemId
                        ? {
                            id: params.itemId,
                            nome: this.props.selectedFilter?.valor?.item?.nome,
                          }
                        : this.props.selectedFilter?.valor?.item || null,
                    acaoId: this.state.acaoId,
                    responsaveis: this.state.responsavelId
                      ? [
                          {
                            id: this.state.responsavelId,
                            nome: this.state.responsavelNome,
                            descricao: this.state.responsavelNome,
                          },
                        ]
                      : this.props.selectedFilter?.valor?.responsavelId
                      ? [
                          {
                            id: this.props.selectedFilter?.valor?.responsavelId,
                            nome: this.props.selectedFilter?.valor
                              ?.responsavelNome,
                          },
                        ]
                      : params?.responsavelId
                      ? [
                          {
                            id: params.responsavelId,
                            nome: params.responsavelNome,
                          },
                        ]
                      : null,
                    listaStatus: this.state.statusId
                      ? [
                          {
                            id: this.state.statusId,
                            descricao: this.state.statusNome,
                          },
                        ]
                      : null,
                    statusId: this.state.statusId
                      ? this.state.statusId
                      : this.props.selectedFilter?.valor?.status?.id,
                    desdobramentoId: this.state.desdobramentoId,
                    organizacaoColaboradoresId:
                      this.state.organizacaoColaboradoresId,
                    subordinadasOrganizacaoColaboradores:
                      this.state.subordinadasOrganizacaoColaboradores,
                    centroCustoId: this.state.centroCustoId,
                    pacoteId: this.state.pacoteId,
                    centrosSubordinados: this.state.centrosSubordinados,
                    pacotesSubordinados: this.state.pacotesSubordinados,
                    tipoOrigemId:
                      parameters?.tipoOrigemId ??
                      this.state.tipoOrigemId ??
                      (params && params.tipoOrigemId) ??
                      this.props.selectedFilter?.valor?.tipoOrigem?.id,
                    tipoOrigemDescricao:
                      this.state.tipoOrigemDescricao ??
                      this.props.selectedFilter?.valor?.tipoOrigem?.descricao,
                    tiposOrigemId: this.state.tiposOrigemId,
                    tiposOrigemDescricao: this.state.tiposOrigemDescricao,
                    somenteAcoesFilhas: this.state.somenteAcoesFilhas,
                    incluirDesdobramento: this.state.incluirDesdobramento,
                    incluirImpactosIndiretos:
                      this.state.incluirImpactosIndiretos,
                    incluirItensFormula: this.state.incluirItensFormula,
                    exibirLookups: parameters?.exibirLookups ?? true,
                    tipoAcao: this.state.tipoAcaoId
                      ? { id: this.state.tipoAcaoId }
                      : null,
                    desdobramentoSubordinados:
                      this.state.desdobramentoSubordinados,
                    porque: this.state.porque,
                    apenasAcoesOrigem: this.state.apenasAcoesOrigem,
                    nivelAcao: this.state.nivelAcao,
                    acoes: this.state.acoes,
                    matrizRiscoId: this.state.matrizRiscoId,
                    matrizRiscoDescricao: this.state.matrizRiscoDescricao,
                    grausRiscoId: this.state.grausRiscoId,
                    grausRiscoNome: this.state.grausRiscoNome,
                    auditoriaId: this.state.auditoriaId,
                    auditoriaNome: this.state.auditoriaNome,
                    auditoriasId: this.state.auditoriasId,
                    auditoriasNome: this.state.auditoriasNome,
                    csaId: this.state.csaId,
                    csaNome: this.state.csaNome,
                    csasId: this.state.csasId,
                    csasNome: this.state.csasNome,
                    pontoControleId: this.state.pontoControleId,
                    pontoControleDescricao: this.state.pontoControleDescricao,
                    pontoControlesId: this.state.pontoControlesId,
                    pontoControlesDescricao: this.state.pontoControlesDescricao,
                    perdaOperacionalId: this.state.perdaOperacionalId,
                    perdaOperacionalDescricao:
                      this.state.perdaOperacionalDescricao,
                    perdasOperacionaisId: this.state.perdasOperacionaisId,
                    perdasOperacionaisDescricao:
                      this.state.perdasOperacionaisDescricao,
                    camposCustomizados: this.state.camposCustomizados,
                    tagsId: this.state.tagsId,
                    tagsDesricao: this.state.tagsDescricao,
                    equipe: this.state.idColaboradorEquipe
                      ? [
                          {
                            id: this.state.idColaboradorEquipe,
                            nome: this.state.nomeColaboradorEquipe,
                          },
                        ]
                      : null,
                    ocultarStatusArquivado: this.state.ocultarStatusArquivado,
                  }
            }
            saved={
              this.props.refreshResultadoArea
                ? this.props.refreshResultadoArea
                : this.state.saved ||
                  this.props.refresh ||
                  this.props.refreshList
            }
            showSearch={hideSearch ? !hideSearch : showToolbar}
            searchComponent={
              showSearchWidget ? (
                <SearchWidget />
              ) : showModal ? (
                <SearchModal />
              ) : showSearchAtualizarAcao ? (
                <SearchAtualizarAcao />
              ) : (
                search
              )
            }
            searchSchema={
              showSearchWidget
                ? SearchWidgetSchema
                : showModal
                ? SearchSchemaModal
                : searchSchema
            }
            filtroId={filtroId ? filtroId : showModal ? 22 : 5}
            usarFiltroSalvo={
              urlApresentacao || filtroLocal
                ? false
                : usarFiltroSalvo && this.state.usarFiltroSalvo
            }
            actions={!disabled && actions}
            onDeleting={this.handleDeleteClick}
            showCustomFields={true}
            tipoItem={100}
            showArquivamento={this.state.acaoConfiguracao.podeArquivarAcoes}
            updateParams={!urlApresentacao ? this.updateParams : null}
            actionsToolBar={actionsToolBar}
            isConsultaExterna={isConsultaExterna}
            showMenu={!isConsultaExterna}
            showExport={showExport}
            hierarchy={false}
            forceSelectedFilter={this.ehApresentacaoComFiltroConfigurado()}
            selectedFilter={
              this.ehApresentacaoComFiltroConfigurado()
                ? this.props.selectedFilter
                : this.state.filtroAtualizado && possuiParametrosUrl
                ? this.state.defaultFilter
                : possuiParametrosUrl && {
                    valor: {
                      dataInicioPrevista: this.state.dataInicioPrevista
                        ? this.state.dataInicioPrevista
                        : this.state.dataInicio
                        ? this.state.dataInicio
                        : null,
                      dataTerminoPrevista: this.state.dataTerminoPrevista
                        ? this.state.dataTerminoPrevista
                        : this.state.dataTermino
                        ? this.state.dataTermino
                        : null,
                      dataInicioRealizada: this.state.dataInicioRealizada,
                      dataTerminoRealizada: this.state.dataTerminoRealizada,
                      codigo: this.state.codigo,
                      descricao: this.state.descricao,
                      farol: this.state.idFarol
                        ? [
                            {
                              id: this.state.idFarol,
                              descricao: this.state.farolDescricao,
                              icone: this.state.farolIcone,
                              cor: this.state.farolCor,
                            },
                          ]
                        : null,
                      areas: this.state.organizacaoId
                        ? [
                            {
                              id: this.state.organizacaoId,
                              nome: this.state.organizacaoNome,
                            },
                          ]
                        : this.state.areaId
                        ? [
                            {
                              id: this.state.areaId,
                              nome: this.state.areaNome,
                            },
                          ]
                        : null,
                      areaSubordinada: this.state.subordinadas
                        ? this.state.subordinadas
                        : this.state.areasSubordinadas
                        ? this.state.areasSubordinadas
                        : false,
                      itens: this.state.itemId
                        ? [
                            {
                              id: this.state.itemId,
                              nome: this.state.itemNome,
                            },
                          ]
                        : null,
                      listaStatus: this.state.statusId
                        ? [
                            {
                              id: this.state.statusId,
                              descricao: this.state.statusNome,
                            },
                          ]
                        : null,
                      responsaveis: this.state.responsaveis
                        ? this.state.responsaveis
                        : this.state.responsavelId
                        ? [
                            {
                              id: this.state.responsavelId,
                              nome: this.state.responsavelNome,
                              descricao: this.state.responsavelNome,
                            },
                          ]
                        : null,
                      apenasAcoesModuloAtual: this.state.apenasAcoesModuloAtual
                        ? this.state.apenasAcoesModuloAtual
                        : false,
                      exibirAcoesComoMembroEquipe: this.state
                        .exibirAcoesComoMembroEquipe
                        ? this.state.exibirAcoesComoMembroEquipe
                        : false,
                      widgetDashboardIndividual: this.state
                        .widgetDashboardIndividual
                        ? this.state.widgetDashboardIndividual
                        : false,
                      filtrarAcoesAreaColaborador: this.state
                        .filtrarAcoesAreaColaborador
                        ? this.state.filtrarAcoesAreaColaborador
                        : false,
                      filtrarAcoesEspelho: this.state.filtrarAcoesEspelho,
                      centroCusto: this.state.centroCustoId
                        ? {
                            id: this.state.centroCustoId,
                            nome: this.state.centroCustoNome,
                          }
                        : null,
                      pacote: this.state.pacoteId
                        ? {
                            id: this.state.pacoteId,
                            nome: this.state.pacoteNome,
                          }
                        : null,
                      centrosSubordinados: this.state.centrosSubordinados
                        ? this.state.centrosSubordinados
                        : false,
                      pacotesSubordinados: this.state.pacotesSubordinados
                        ? this.state.pacotesSubordinados
                        : false,
                      tipoOrigem: this.state.tipoOrigemId
                        ? {
                            id: this.state.tipoOrigemId,
                            descricao: this.state.tipoOrigemDescricao,
                          }
                        : null,
                      tiposOrigem: this.state.tiposOrigemId
                        ? this.state.tiposOrigemId.map((id, index) => {
                            return {
                              id: this.state.tiposOrigemId[index],
                              descricao: this.state.tiposOrigemDescricao[index],
                            };
                          })
                        : null,
                      areaColaboradores: this.state.organizacaoColaboradoresId
                        ? {
                            id: this.state.organizacaoColaboradoresId,
                            nome: this.state.organizacaoColaboradoresNome,
                          }
                        : null,
                      tipoAcao: this.state.tipoAcaoId
                        ? { id: this.state.tipoAcaoId }
                        : null,
                      desdobramento: this.state.desdobramentoId
                        ? {
                            id: this.state.desdobramentoId,
                            descricao: this.state.desdobramentoDescricao,
                          }
                        : null,
                      desdobramentoSubordinados: this.state
                        .desdobramentoSubordinados
                        ? this.state.desdobramentoSubordinados
                        : false,
                      incluirDesdobramento: this.state.incluirDesdobramento
                        ? this.state.incluirDesdobramento
                        : false,
                      incluirImpactosIndiretos: this.state
                        .incluirImpactosIndiretos
                        ? this.state.incluirImpactosIndiretos
                        : false,
                      incluirItensFormula: this.state.incluirItensFormula
                        ? this.state.incluirItensFormula
                        : false,
                      AreaSubordinadaColaboradores: this.state
                        .subordinadasOrganizacaoColaboradores
                        ? this.state.subordinadasOrganizacaoColaboradores
                        : false,
                      porque: this.state.porque,
                      apenasAcoesOrigem: this.state.apenasAcoesOrigem
                        ? this.state.apenasAcoesOrigem
                        : false,
                      nivelAcao: this.state.nivelAcao
                        ? this.state.nivelAcao
                        : null,
                      somenteAcoesFilhas: this.state.somenteAcoesFilhas,
                      matrizRisco: this.state.matrizRiscoId
                        ? {
                            id: this.state.matrizRiscoId,
                            descricao: this.state.matrizRiscoDescricao,
                          }
                        : null,
                      grausRisco: this.state.grausRiscoId
                        ? this.state.grausRiscoId.map((id, index) => {
                            return {
                              id: this.state.grausRiscoId[index],
                              descricao: this.state.grausRiscoNome[index],
                            };
                          })
                        : null,
                      auditorias: this.state.auditoriaId
                        ? [
                            {
                              id: this.state.auditoriaId,
                              nome: this.state.auditoriaNome,
                            },
                          ]
                        : this.state.auditoriasId
                        ? this.state.auditoriasId.map((id, index) => {
                            return {
                              id: this.state.auditoriasId[index],
                              nome: this.state.auditoriasNome[index],
                            };
                          })
                        : null,
                      controlSelfAssessments: this.state.csaId
                        ? [
                            {
                              id: this.state.csaId,
                              nome: this.state.csaNome,
                            },
                          ]
                        : this.state.csasId
                        ? this.state.csasId.map((id, index) => {
                            return {
                              id: this.state.csasId[index],
                              nome: this.state.csasNome[index],
                            };
                          })
                        : null,
                      pontosDeControle: this.state.pontoControleId
                        ? [
                            {
                              id: this.state.pontoControleId,
                              descricao: this.state.pontoControleDescricao,
                            },
                          ]
                        : this.state.pontoControlesId
                        ? this.state.pontoControlesId.map((id, index) => {
                            return {
                              id: this.state.pontoControlesId[index],
                              descricao:
                                this.state.pontoControlesDescricao[index],
                            };
                          })
                        : null,
                      perdasOperacionais: this.state.perdaOperacionalId
                        ? [
                            {
                              id: this.state.perdaOperacionalId,
                              descricao: this.state.perdaOperacionalDescricao,
                            },
                          ]
                        : this.state.perdasOperacionaisId
                        ? this.state.perdasOperacionaisId.map((id, index) => {
                            return {
                              id: this.state.perdasOperacionaisId[index],
                              descricao:
                                this.state.perdasOperacionaisDescricao[index],
                            };
                          })
                        : null,
                      camposCustomizados: this.state.camposCustomizados
                        ? this.state.camposCustomizados
                        : null,
                      tags: this.state.tagsId
                        ? this.state.tagsId.map((id, index) => {
                            return {
                              id: this.state.tagsId[index],
                              descricao: this.state.tagsDescricao[index],
                            };
                          })
                        : null,
                      equipe: this.state.idColaboradorEquipe
                        ? [
                            {
                              id: this.state.idColaboradorEquipe,
                              nome: this.state.nomeColaboradorEquipe,
                            },
                          ]
                        : null,
                      acoes: this.state.acoes,
                    },
                  }
            }
            openLastFilter={
              this.ehApresentacaoComFiltroConfigurado()
                ? false
                : !possuiParametrosUrl
            }
            ehAcao={true}
          >
            <ListColumn
              headerText={intl.formatMessage({ id: 'item' })}
              valueField="nomeItem"
              sortField="Item.UltimaVersao.Nome"
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'itemOrigem' })}
              valueField="itemOrigem"
              sortField="itemOrigem"
              default
            />
            <ListColumn
              center
              tree={false}
              headerText={intl.formatMessage({ id: 'codigo' })}
              valueField="codigo"
              sortField="UltimaVersao.CodigoOrdenacao"
              default
            />
            <ListColumn
              headerText={capitalizeFirstLetter(
                intl.formatMessage({ id: 'descricao' })
              )}
              valueField="descricao"
              sortField="UltimaVersao.Descricao"
              valueFunction={this.renderDescricao}
              default
              required
            />
            <ListColumn
              visible={
                moduloLicenca &&
                (!this.form.component.apenasAcoesModuloAtual ||
                  moduloAtual.id === 2)
              }
              headerText={intl.formatMessage(
                { id: 'centroDeCusto' },
                { centrocusto: resources.centrocusto }
              )}
              valueField="centroCusto"
              sortField="centroCusto"
              valueFunction={this.renderCentroCusto}
              default
            />
            <ListColumn
              visible={
                moduloLicenca &&
                (!this.form.component.apenasAcoesModuloAtual ||
                  moduloAtual.id === 2)
              }
              headerText={intl.formatMessage({ id: 'pacoteConta' })}
              valueField="pacote"
              sortField="pacote"
              valueFunction={this.renderPacote}
              default
            />
            <ListColumn
              headerText={capitalizeFirstLetter(resources.responsavel)}
              valueField="responsavel"
              valueFunction={this.renderResponsavel}
              sortField="UltimaVersao.Responsavel.Nome"
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'dataInicioPrevista' })}
              valueField="dataInicioPrevista"
              sortField="UltimaVersao.dataInicioPrevista"
              valueFunction={this.renderDataInicioPrevista}
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'dataTerminoPrevista' })}
              valueField="dataTerminoPrevista"
              sortField="UltimaVersao.dataTerminoPrevista"
              valueFunction={this.renderDataTerminoPrevista}
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'dataInicioRealizada' })}
              valueField="dataInicioRealizada"
              sortField="UltimaVersao.dataInicioRealizada"
              valueFunction={this.renderDataInicioRealizada}
              default
              required={this.props.atualizarAcoes}
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'dataTerminoRealizada' })}
              valueField="dataTerminoRealizada"
              sortField="UltimaVersao.dataTerminoRealizada"
              valueFunction={this.renderDataTerminoRealizada}
              default
              required={this.props.atualizarAcoes}
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'status' })}
              valueField="status"
              valueFunction={this.renderStatus}
              default
            />
            <ListColumn
              headerText={capitalizeFirstLetter(resources.farol)}
              valueField="farolAcao"
              sortField="UltimaVersao.FarolAcao"
              valueFunction={this.renderFarol}
              default
            />
            <ListColumn
              headerText={capitalizeFirstLetter(resources.area)}
              valueField="area"
              sortField="Item.UltimaVersao.Area.Nome"
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.ocultarPercentualPrevisto}
              headerText={intl.formatMessage(
                { id: 'label.percentualPrevisto' },
                { percprevisto: resources.percprevisto }
              )}
              valueField="percentualPrevisto"
              sortField="UltimaVersao.percentualPrevisto"
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.ocultarPercentualRealizado}
              headerText={intl.formatMessage(
                { id: 'percentualRealizado' },
                { percrealizado: resources.percrealizado }
              )}
              valueField="percentualRealizado"
              {...(atualizarAcoes && {
                valueFunction: this.renderPercentualRealizado,
              })}
              sortField="UltimaVersao.percentualRealizado"
              required={this.props.atualizarAcoes}
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.ocultarInvestimentoPrevisto}
              headerText={intl.formatMessage(
                { id: 'investimentoPrevisto' },
                { investimento: resources.investimento }
              )}
              valueField="investimentoPrevisto"
              sortField="UltimaVersao.investimentoPrevisto"
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.ocultarInvestimentoRealizado}
              headerText={intl.formatMessage(
                { id: 'investimentoRealizado' },
                { investimento: resources.investimento }
              )}
              valueField="investimentoRealizado"
              sortField="UltimaVersao.investimentoRealizado"
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'custeioPrevisto' },
                { custeio: resources.custeio }
              )}
              valueField="custeioPrevisto"
              sortField="UltimaVersao.custeioPrevisto"
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'custeioRealizado' },
                { custeio: resources.custeio }
              )}
              valueField="custeioRealizado"
              sortField="UltimaVersao.custeioRealizado"
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'label.duracao' })}
              valueField="duracao"
              sortField="UltimaVersao.duracao"
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.ocultarEsforco}
              headerText={intl.formatMessage({ id: 'esforco' })}
              valueField="esforco"
              sortField="UltimaVersao.esforco"
            />
            <ListColumn
              headerText={capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.itensVinculados' })
              )}
              valueField="idIntegracaoItensVinculados"
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'tipoOrigem' })}
              valueField="tipoOrigem"
              valueFunction={(value) => this.renderTipoOrigem(value, intl)}
              default
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'tipoAcao' },
                { acao: resources.acao }
              )}
              valueField="tipoAcao"
              valueFunction={this.renderTipoAcao}
              default
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'ganhosMeta' },
                { meta: resources.meta }
              )}
              valueField="ganhosMeta"
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'ganhosRealizado' })}
              valueField="ganhosRealizado"
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'label.desvio' })}
              valueField="desvioGanho"
              default
            />
            <ListColumn
              center
              visible={this.state.acaoConfiguracao.habilitarChecklistTarefas}
              headerText={intl.formatMessage({ id: 'checklistTarefas' })}
              valueField="checklist"
              valueFunction={this.renderChecklist}
              default
            />
            <ListColumn
              center
              visible={this.state.acaoConfiguracao.utilizarPorque}
              headerText={capitalizeFirstLetter(resources.porque)}
              valueField="porque"
              default
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.utilizarCausasImpactadas}
              headerText={intl.formatMessage(
                { id: 'pontosProblematicos' },
                { pontosproblematicos: resources.pontosproblematicos }
              )}
              valueField="pontosProblematicos"
              valueFunction={this.renderPontosProblematicos}
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'nivelAcao' },
                { acao: resources.acao }
              )}
              valueField="nivelAcao"
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'criadorAcao' },
                { acao: resources.acao }
              )}
              valueField="criadorAcao"
              valueFunction={this.renderCreator}
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'dataCriacaoAcao' },
                { acao: resources.acao }
              )}
              valueField="dataCriacaoAcao"
              valueFunction={this.renderCreationDate}
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.habilitarBaseline}
              headerText={intl.formatMessage({ id: 'baselineInicial' })}
              valueField="baselineInicial"
              sortField="UltimaVersao.baselineInicial"
              valueFunction={this.renderBaselineInicial}
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.habilitarBaseline}
              headerText={intl.formatMessage({ id: 'baselineTermino' })}
              valueField="baselineTermino"
              sortField="UltimaVersao.baselineTermino"
              valueFunction={this.renderBaselineTermino}
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.vincularAcaoNaMatriz}
              headerText={intl.formatMessage(
                { id: 'matrizRisco' },
                { risco: resources.risco }
              )}
              valueField="descricaoMatrizRisco"
            />
            <ListColumn
              visible={this.state.acaoConfiguracao.podeVisualizarTag}
              headerText={intl.formatMessage(
                { id: 'tags' },
                { tags: resources.tags }
              )}
              valueField="tags"
              valueFunction={this.renderTags}
              default
            />
            <ListColumn
              headerText={intl.formatMessage(
                { id: 'grauRisco' },
                { risco: resources.risco }
              )}
              valueField="grauRisco"
              visible={
                this.state.acaoConfiguracao
                  .exibirGrauDescricaoAcaoVinculadaRisco
              }
              valueFunction={(item) =>
                this.renderGrauRisco(item && item.grauRisco, false, item)
              }
              default
            />
            <ListColumn
              headerText={`${intl.formatMessage({
                id: 'descricao',
              })} ${intl.formatMessage(
                { id: 'grauRisco' },
                { risco: resources.risco }
              )}`}
              visible={
                this.state.acaoConfiguracao
                  .exibirGrauDescricaoAcaoVinculadaRisco
              }
              valueField="descricaoGrauRisco"
              valueFunction={(item) =>
                this.renderDescricaoGrauRisco(item, 'descricaoGrauRisco')
              }
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'equipe' })}
              valueField="equipe"
              valueFunction={this.renderEquipe}
              visible={this.state.acaoConfiguracao.habilitarEquipe}
            />
            <ListColumn
              headerText={resources.auditoria}
              valueField="auditorias"
              default
            />
            <ListColumn
              headerText={intl.formatMessage({
                id: 'labelControlSelfAssessment',
              })}
              valueField="controlSelfAssessments"
              default
            />
            <ListColumn
              headerText={capitalizeFirstLetter(resources.perdaoperacional)}
              valueField="perdasOperacionais"
            />
            <ListColumn
              headerText={resources.pontodecontrole}
              valueField="pontosDeControle"
              default
            />
            <ListColumn
              headerText={`${intl.formatMessage({
                id: 'labelStatusBaseLine',
              })} `}
              visible={this.state.acaoConfiguracao.exibirStatusBaseLineTermino}
              valueField="statusBaseLineTermino"
              valueFunction={(item) => this.renderStatusBaseLine(item)}
              default
            />
            <ListColumn
              center
              headerText={intl.formatMessage({ id: 'label.comentarios' })}
              valueField="quantidadeComentarios"
              valueFunction={this.renderComentarios}
              default
            />
          </List>
        )}
        {!this.state.usandoKanban && <Legenda mode={this.props.mode}></Legenda>}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    moduloAtual: state.user.moduloAtual,
    user: state.user,
    lang: state.user && state.user.idioma,
    viewType: state.viewType,
    configuracaoSistema: state.user.configuracao,
  };
}
export default injectIntl(connect(mapStateToProps)(AcaoList));
